module.exports = __webpack_public_path__ + "static/assets/511e98f941a7d8f224ef3487c6f9a219.svg";